import summarizeStyle from "./summarize.module.css";
import React, { useState } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import WabaMetricsTable from "../../components/tables/WabaMetricsTable";
import ActionBtn from "../../components/UI/actionbtn";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../services/api";
import { toast } from "react-toastify";
import { config } from "../../services/utils";

export default function SmsList() {
  const defaultWabaSearch = {
    phone: "",
    origin: "",
    message: "",
  };

  const [wabaSearch, setWabaSearch] = useState({ ...defaultWabaSearch });
  const [retornoAPI, setRetornoAPI] = useState([]);

  const handleChange = (type, value) => {
    let _wabaSearch = { ...wabaSearch };
    _wabaSearch[type] = value;
    setWabaSearch({ ..._wabaSearch });
  };

  const loadTables = async () => {
    if (wabaSearch.phone === "" || wabaSearch.origin === "") {
      toast.warning("Preencha os campos telefone e origem para a busca");
      return;
    }

    const encodedOrigin = encodeURIComponent(wabaSearch.origin);
    const encodedPhone = encodeURIComponent(wabaSearch.phone);
    let encodedMessage = "";
    if (wabaSearch.message.length) {
      encodedMessage = encodeURIComponent(wabaSearch.message);
    }

    try {
      const res = await api.get(
        `api/database/report/wabametrics?origin=${encodedOrigin}&phone=${encodedPhone}&message=${encodedMessage}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.length === 0) {
        toast.error("Erro #004: Sem resultado de busca");
        return;
      }
      setRetornoAPI(res.data);
      toast.success("Dados carregados com sucesso");
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
      toast.error("Erro ao carregar dados");
    }
  };

  const cleanSearch = () => {
    setWabaSearch({ ...defaultWabaSearch });
    setRetornoAPI([]);
  };

  return (
    <div className={summarizeStyle.summarize}>
      <div className="d-flex align-items-center justify-content-between pe-4">
        <p className="titlePage">Métricas waba</p>
        <div className="d-flex align-items-center">
          <div
            className={`d-flex align-items-center ${summarizeStyle.containerInput} me-3`}
          >
            <label className="defaultLabel me-2">Mensagem:</label>
            <input
              className="input-bootstrap"
              type="text"
              placeholder="Olá, tudo bem?"
              onChange={(e) => handleChange("message", e.target.value)}
            />
          </div>
          <div
            className={`d-flex align-items-center ${summarizeStyle.containerTimeHeader} me-3`}
          >
            <label className="defaultLabel me-2">Telefone:</label>
            <input
              className="input-bootstrap"
              type="text"
              placeholder="+550000000000"
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </div>
          <div
            className={`d-flex align-items-center ${summarizeStyle.containerTimeHeader} me-3`}
          >
            <label className="defaultLabel me-2">Origem:</label>
            <select
              className="select-bootstrap"
              value={wabaSearch.origin}
              onChange={(e) => handleChange("origin", e.target.value)}
            >
              <option defaultValue="" hidden>
                {" "}
                Selecione ...
              </option>
              {config.summarize.map((value) => (
                <option value={value.origin}>{value.visualName}</option>
              ))}
            </select>
          </div>

          <div
            onClick={() => {
              cleanSearch();
            }}
          >
            <ActionBtn color="yellow" icon={<SearchOffIcon />} />
          </div>

          <div
            onClick={() => {
              loadTables();
            }}
          >
            <ActionBtn color="green" icon={<SearchIcon />} />
          </div>
        </div>
      </div>
      <div className={summarizeStyle.sumBottomBox}>
        <StyledEngineProvider injectFirst>
          <WabaMetricsTable data={retornoAPI} />
        </StyledEngineProvider>
      </div>
    </div>
  );
}
